import {
  ArrayList_init_$Create$2qnngtk1et9r9 as ArrayList_init_$Create$,
  Unit_instance104q5opgivhr8 as Unit_instance,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  equals2au1ep9vhcato as equals,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  isInterface3d6p8outrmvmk as isInterface,
  hashCodeq5arwsb9dgti as hashCode,
  toMutableMapr5f3w62lv8sk as toMutableMap,
  emptyMapr06gerzljqtm as emptyMap,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  toString30pk9tzaqopn as toString,
} from './kotlin-kotlin-stdlib.mjs';
import {
  FlowCollector26clgpmzihvke as FlowCollector,
  MutableStateFlow34bfoyvwu8czu as MutableStateFlow,
} from './kotlinx-coroutines-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForInterface(ICacheCleaner, 'ICacheCleaner', VOID, VOID, VOID, [0]);
initMetadataForClass(CacheCleanerRegistry, 'CacheCleanerRegistry', CacheCleanerRegistry, VOID, [ICacheCleaner], [0]);
initMetadataForInterface(ICache, 'ICache', VOID, VOID, VOID, [2, 1, 0]);
initMetadataForLambda(InMemoryCache$get$o$collect$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($collectCOROUTINE$1, CoroutineImpl);
initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
initMetadataForClass(InMemoryCache$get$$inlined$map$1, VOID, VOID, VOID, VOID, [1]);
initMetadataForClass(InMemoryCache, 'InMemoryCache', InMemoryCache, VOID, [ICache], [2, 1, 0]);
function dataOrNull() {
  var tmp;
  if (this instanceof Empty) {
    tmp = null;
  } else {
    if (this instanceof Loaded) {
      tmp = this.v2b_1;
    } else {
      if (this instanceof Stale) {
        tmp = this.u2b_1;
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  return tmp;
}
function map(mapper) {
  var tmp;
  if (this instanceof Empty) {
    tmp = this;
  } else {
    if (this instanceof Loaded) {
      tmp = new Loaded(mapper(this.v2b_1));
    } else {
      if (this instanceof Stale) {
        tmp = new Stale(mapper(this.u2b_1));
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  return tmp;
}
initMetadataForInterface(CacheData, 'CacheData');
initMetadataForObject(Empty, 'Empty', VOID, VOID, [CacheData]);
initMetadataForClass(Stale, 'Stale', VOID, VOID, [CacheData]);
initMetadataForClass(Loaded, 'Loaded', VOID, VOID, [CacheData]);
initMetadataForClass(InMemoryCacheData, 'InMemoryCacheData');
initMetadataForClass(Loaded_0, 'Loaded', VOID, InMemoryCacheData);
initMetadataForClass(Stale_0, 'Stale', VOID, InMemoryCacheData);
//endregion
function CacheCleanerRegistry() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.f2a_1 = ArrayList_init_$Create$();
}
protoOf(CacheCleanerRegistry).g2a = function (cache) {
  this.f2a_1.e(cache);
  return cache;
};
function ICache() {
}
function ICacheCleaner() {
}
function InMemoryCache$get$o$collect$slambda($$this$unsafeFlow, $key, resultContinuation) {
  this.r2a_1 = $$this$unsafeFlow;
  this.s2a_1 = $key;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(InMemoryCache$get$o$collect$slambda).y2a = function (value, $completion) {
  var tmp = this.z2a(value, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(InMemoryCache$get$o$collect$slambda).h9 = function (p1, $completion) {
  return this.y2a((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
};
protoOf(InMemoryCache$get$o$collect$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          var tmp_0 = this;
          tmp_0.u2a_1 = this.r2a_1;
          var tmp_1 = this;
          tmp_1.v2a_1 = this.t2a_1;
          this.w2a_1 = this.u2a_1;
          this.x2a_1 = this.v2a_1;
          this.n8_1 = 1;
          var tmp0_safe_receiver = this.x2a_1.a2(this.s2a_1);
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toCacheData(tmp0_safe_receiver);
          suspendResult = this.w2a_1.b1z(tmp1_elvis_lhs == null ? Empty_instance : tmp1_elvis_lhs, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(InMemoryCache$get$o$collect$slambda).z2a = function (value, completion) {
  var i = new InMemoryCache$get$o$collect$slambda(this.r2a_1, this.s2a_1, completion);
  i.t2a_1 = value;
  return i;
};
function InMemoryCache$get$o$collect$slambda_0($$this$unsafeFlow, $key, resultContinuation) {
  var i = new InMemoryCache$get$o$collect$slambda($$this$unsafeFlow, $key, resultContinuation);
  var l = function (value, $completion) {
    return i.y2a(value, $completion);
  };
  l.$arity = 1;
  return l;
}
function $collectCOROUTINE$1(_this__u8e3s4, collector, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.i2b_1 = _this__u8e3s4;
  this.j2b_1 = collector;
}
protoOf($collectCOROUTINE$1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          var tmp_0 = this;
          tmp_0.k2b_1 = this.j2b_1;
          this.l2b_1 = this.k2b_1;
          this.n8_1 = 1;
          var tmp_1 = InMemoryCache$get$o$collect$slambda_0(this.l2b_1, this.i2b_1.n2b_1, null);
          suspendResult = this.i2b_1.m2b_1.h1y(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function onCache($this, block) {
  var update = InMemoryCache$onCache$lambda(block);
  var tmp0 = $this.o2b_1;
  $l$block: {
    // Inline function 'kotlinx.coroutines.flow.update' call
    while (true) {
      var prevValue = tmp0.t();
      var nextValue = update(prevValue);
      if (tmp0.t22(prevValue, nextValue)) {
        break $l$block;
      }
    }
  }
}
function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
  this.p2b_1 = function_0;
}
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).b1z = function (value, $completion) {
  return this.p2b_1(value, $completion);
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).k3 = function () {
  return this.p2b_1;
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, FlowCollector) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.k3(), other.k3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).hashCode = function () {
  return hashCode(this.k3());
};
function InMemoryCache$get$$inlined$map$1($this, $key) {
  this.m2b_1 = $this;
  this.n2b_1 = $key;
}
protoOf(InMemoryCache$get$$inlined$map$1).c1z = function (collector, $completion) {
  var tmp = new $collectCOROUTINE$1(this, collector, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(InMemoryCache$get$$inlined$map$1).h1y = function (collector, $completion) {
  return this.c1z(collector, $completion);
};
function InMemoryCache$put$lambda($key, $value) {
  return function ($this$onCache) {
    $this$onCache.h2($key, new Loaded_0($value));
    return Unit_instance;
  };
}
function InMemoryCache$onCache$lambda($block) {
  return function (_this__u8e3s4) {
    var newMap = toMutableMap(_this__u8e3s4);
    $block(newMap);
    return newMap;
  };
}
function InMemoryCache() {
  var tmp = this;
  // Inline function 'kotlin.collections.mapOf' call
  var tmp$ret$0 = emptyMap();
  tmp.o2b_1 = MutableStateFlow(tmp$ret$0);
}
protoOf(InMemoryCache).h2a = function (key) {
  // Inline function 'kotlinx.coroutines.flow.map' call
  // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
  var this_0 = this.o2b_1;
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new InMemoryCache$get$$inlined$map$1(this_0, key);
};
protoOf(InMemoryCache).i2a = function (key, value, $completion) {
  onCache(this, InMemoryCache$put$lambda(key, value));
  return Unit_instance;
};
function toCacheData(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof Loaded_0) {
    tmp = new Loaded(_this__u8e3s4.r2b_1);
  } else {
    if (_this__u8e3s4 instanceof Stale_0) {
      tmp = new Stale(_this__u8e3s4.q2b_1);
    } else {
      noWhenBranchMatchedException();
    }
  }
  return tmp;
}
function Empty() {
}
protoOf(Empty).toString = function () {
  return 'Empty';
};
protoOf(Empty).hashCode = function () {
  return 1471650610;
};
protoOf(Empty).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Empty))
    return false;
  other instanceof Empty || THROW_CCE();
  return true;
};
var Empty_instance;
function Empty_getInstance() {
  return Empty_instance;
}
function Stale(data) {
  this.u2b_1 = data;
}
protoOf(Stale).toString = function () {
  return 'Stale(data=' + toString(this.u2b_1) + ')';
};
protoOf(Stale).hashCode = function () {
  return this.u2b_1 == null ? 0 : hashCode(this.u2b_1);
};
protoOf(Stale).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Stale))
    return false;
  var tmp0_other_with_cast = other instanceof Stale ? other : THROW_CCE();
  if (!equals(this.u2b_1, tmp0_other_with_cast.u2b_1))
    return false;
  return true;
};
function Loaded(data) {
  this.v2b_1 = data;
}
protoOf(Loaded).toString = function () {
  return 'Loaded(data=' + toString(this.v2b_1) + ')';
};
protoOf(Loaded).hashCode = function () {
  return this.v2b_1 == null ? 0 : hashCode(this.v2b_1);
};
protoOf(Loaded).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Loaded))
    return false;
  var tmp0_other_with_cast = other instanceof Loaded ? other : THROW_CCE();
  if (!equals(this.v2b_1, tmp0_other_with_cast.v2b_1))
    return false;
  return true;
};
function CacheData() {
}
function emptyIfNull(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof Empty) {
    tmp = _this__u8e3s4;
  } else {
    if (_this__u8e3s4 instanceof Loaded) {
      var value = _this__u8e3s4.v2b_1;
      var tmp_0;
      if (value == null) {
        tmp_0 = Empty_instance;
      } else {
        tmp_0 = new Loaded(value);
      }
      tmp = tmp_0;
    } else {
      if (_this__u8e3s4 instanceof Stale) {
        var value_0 = _this__u8e3s4.u2b_1;
        var tmp_1;
        if (value_0 == null) {
          tmp_1 = Empty_instance;
        } else {
          tmp_1 = new Stale(value_0);
        }
        tmp = tmp_1;
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  return tmp;
}
function Loaded_0(data) {
  InMemoryCacheData.call(this);
  this.r2b_1 = data;
}
protoOf(Loaded_0).toString = function () {
  return 'Loaded(data=' + toString(this.r2b_1) + ')';
};
protoOf(Loaded_0).hashCode = function () {
  return this.r2b_1 == null ? 0 : hashCode(this.r2b_1);
};
protoOf(Loaded_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Loaded_0))
    return false;
  var tmp0_other_with_cast = other instanceof Loaded_0 ? other : THROW_CCE();
  if (!equals(this.r2b_1, tmp0_other_with_cast.r2b_1))
    return false;
  return true;
};
function Stale_0() {
}
function InMemoryCacheData() {
}
//region block: post-declaration
protoOf(Empty).s2b = dataOrNull;
protoOf(Empty).t2b = map;
protoOf(Stale).s2b = dataOrNull;
protoOf(Stale).t2b = map;
protoOf(Loaded).s2b = dataOrNull;
protoOf(Loaded).t2b = map;
//endregion
//region block: init
Empty_instance = new Empty();
//endregion
//region block: exports
export {
  emptyIfNull as emptyIfNull1t7oeph6e4stc,
  CacheCleanerRegistry as CacheCleanerRegistry1txtxriyqr3kw,
  ICacheCleaner as ICacheCleaner2xrjdwipcre7v,
  ICache as ICache3bwileb79diof,
  InMemoryCache as InMemoryCache2v1xems7p2diw,
};
//endregion

